export function iframeContentWidth() {
    const parent = $(".content");
    parent.each(function () {
        $(this).find("iframe").each(function () {
            $(this).parent().addClass("responsive-iframe");
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/iframeContentWidth.js